<template>
<div class="wrap">
        <Header :initIsColorBlack="isColorBlack" />
        <Tabs />
        <!-- banner -->
        <div id="featured">
            <VueSlickCarousel v-bind="settings0" class="slider" ref="featuredSlider" @beforeChange="handleBeforeChange(0)" v-if="bannerList.length > 0">
                <a v-for="(item, index) in bannerList" :key="index" class="slide" @click="bannerClick(item)">
                    <img :src="siteConfig.cdnUrl + '/KR/banner/'+ item.url" />
                </a>
                <!-- <router-link tag="a" v-for="(item, index) in bannerList" :key="index" :to="item.link" class="slide">
                    <img :src="siteConfig.cdnUrl + '/KR/banner/'+ item.url" />
                </router-link> -->
            </VueSlickCarousel>
        </div>
        <!-- banner end -->
        <!-- section2 -->
        <div id="section2" class="section" v-if="hitList.length > 0">
            <div class="container">
                <h1 class="title">인기 작품</h1>
                <h3 class="sub_title">이번주 최고 인기 작품들을 감상하세요!</h3>
                <div class="best_box">
                    <div class="hot" @click="moveDetail(hitFeatured[0])">
                        <img src="../assets/images/adult_mark.svg" alt="성인 마크" class="adult_mark" v-if="hitFeatured[0].adult === 1">
                        <!-- <img :src="siteConfig.cdnUrl + '/KR/bigtitle/'+ hitFeatured[0].englishName + '.jpg'" class="pc"> -->
                        <img src="../assets/images/hot/dragon.png" class="pc" v-if="!$store.state.isCheckedAdult">
                        <img src="../assets/images/hot/newface_a.png" class="pc" v-else>
                        
                        <img :src="siteConfig.cdnUrl + '/KR/title/'+ hitFeatured[0].englishName + '.jpg'" class="mobile">
                        <div class="top">
                            <p>{{hitFeatured[0].titleName}}</p>
                            <div class="hot_mark">HOT</div>
                        </div>
                        <div class="bottom">
                            <!-- <div class="see"></div> -->
                            <!-- <p class="what">{{getCategoryName(hitFeatured[0].category)}}</p> -->
                            <p class="desc" v-html="hitFeatured[0].desc"></p>
                            <!-- <p>900만+</p> -->
                        </div>
                    </div>

                    <b-row cols="3" class="up">
                        <b-col v-for="(item, index) in hitList[0].list" :key="index">
                            <img src="../assets/images/adult_mark.svg" alt="성인 마크" class="adult_mark" v-if="item.adult === 1">
                            <div class="item" @click="moveDetail(item)">
                                <div class="top">
                                    <img :src="siteConfig.cdnUrl + '/KR/title/' + item.englishName + '.jpg'">
                                </div>
                                <div class="bottom">
                                    <div class="top_text">
                                        <p>{{item.titleName}}</p>
                                        <!-- <div class="up_mark">UP</div> -->
                                    </div>
                                    <div class="bottom_text">
                                        <!-- <div class="see"></div> -->
                                        <!-- <p>{{7-index}}00만+</p> -->
                                        <!-- <p class="what">{{getCategoryName(item.category)}}</p> -->
                                        <p class="desc" v-html="item.desc"></p>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <!-- <div class="next" @click="moveSlide('next', 'hit')">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
                <div class="prev" @click="moveSlide('prev', 'hit')">
                    <img src="../assets/images/next.svg" alt="next">
                </div> -->
            </div>
        </div>
        <!-- section2 end -->
        <!-- section1 -->
        <div id="section1" class="section curation" v-if="newUpdateList.length > 0">
            <div class="container">
                <h1 class="title">신규 업데이트 작품</h1>
                <h3 class="sub_title">새롭게 추가된 명작을 확인하세요!</h3>
            </div>
            <div class="book_table">
                <div class="container">
                    <div class="row">
                        <div v-for="(item, index) in newUpdateList" :key="index" @click="moveDetail(item)" class="col" :class="[index >= selectedNewUpdateSlideIdx && index < selectedNewUpdateSlideIdx + 5 ? 'show' : '' ]">
                            <p>{{item.titleName}}</p>
                            <div class="star">
                                <img src="../assets/images/star_yellow.svg" alt="별점" v-if="item.starAvg >= 1">
                                <img src="../assets/images/star_g.svg" alt="별점" v-else>
                                <img src="../assets/images/star_yellow.svg" alt="별점" v-if="item.starAvg >= 2">
                                <img src="../assets/images/star_g.svg" alt="별점" v-else>
                                <img src="../assets/images/star_yellow.svg" alt="별점" v-if="item.starAvg >= 3">
                                <img src="../assets/images/star_g.svg" alt="별점" v-else>
                                <img src="../assets/images/star_yellow.svg" alt="별점" v-if="item.starAvg >= 4">
                                <img src="../assets/images/star_g.svg" alt="별점" v-else>
                                <img src="../assets/images/star_yellow.svg" alt="별점" v-if="item.starAvg >= 5">
                                <img src="../assets/images/star_g.svg" alt="별점" v-else>
                            </div>
                            <img src="../assets/images/adult_mark.svg" alt="성인 마크" class="adult_mark" v-if="item.adult === 1">
                            <img :src="siteConfig.cdnUrl + '/KR/bigtitle/'+ item.englishName + '.jpg'">
                        </div>
                    </div>
                    <div class="next" @click="moveSlide('next', 'newUpdate')">
                        <img src="../assets/images/next.svg" alt="next">
                    </div>
                    <div class="prev" @click="moveSlide('prev', 'newUpdate')">
                        <img src="../assets/images/next.svg" alt="next">
                    </div>
                </div>
            </div>
            <div class="work">
                <div class="container">
                    <div class="work_box" v-for="(item, index) in newUpdateList" :key="index" @click="moveDetail(item)">
                        <div class="left">
                            <p>{{item.titleName}}</p>
                            <p v-html="item.desc"></p>
                            <div class="left_inner">
                                <p class="genre_3">{{getCategoryName(item.category)}}</p>
                                <!-- <p class="up_check">up</p> -->
                            </div>
                            <router-link tag="div" to="/" class="go_see">
                                <p>보러가기</p>
                                <img src="../assets/images/mobile/icon_veiw.svg" alt="화살표">
                            </router-link>
                        </div>
                        <div class="right">
                            <img src="../assets/images/adult_mark.svg" alt="성인 마크" class="adult_mark" v-if="item.adult === 1">
                            <img :src="siteConfig.cdnUrl + '/KR/bigtitle/'+ item.englishName + '.jpg'">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- section1 end -->
        <!-- section3 -->
        <div id="section3" class="section">
            <div class="container">
                <h1 class="title">장르 카테고리</h1>
                <h3 class="sub_title">다양한 장르의 작품들을 즐겨보세요</h3>
                <b-row cols="6">
                    <b-col v-for="(item,index) in categoryList" :key="index" tag="div">
                        <router-link tag="div" :to="'/Category/' + item.idx" class="col">
                            <!-- <img src="../assets/images/category/all.svg" alt="전체"> -->
                            <p>{{item.name}}</p>
                        </router-link>
                    </b-col>
                </b-row>
            </div>
        </div>
        <!-- section3 end -->
        <!-- advertising -->
        <div id="advertising1" class="advertising">
            <router-link tag="div" to="/ArtubeLeague" class="container">
                <img src="../assets/images/league_banner1.png" alt="아튜브리그 배너">
            </router-link>
        </div>
        <!-- advertising end -->
        <!-- section4 -->
        <div id="section4" class="section curation" v-if="saleList.length > 0">
            <div class="container">
                <div class="m_more_box">
                    <h1 class="title">할인 작품 소개</h1>
                    <!-- <router-link tag="a" to="/" class="more">더보기 +</router-link> -->
                </div>
                <h3 class="sub_title">코인이 부족해도 걱정 NO!</h3>
                <!-- <div class="pagenation">
                    <div class="circle" :class="[index === selectedSaleSlideIdx ? 'check' : '']" v-for="(item, index) in saleList" :key="index" @click="changeSlideIdx('sale', index)"></div>
                </div> -->
                <div class="row">
                    <div v-for="(item, index) in saleList" :key="index" @click="moveDetail(item)" class="col" :class="[index >= selectedSaleSlideIdx && index < selectedSaleSlideIdx + 4 ? 'show' : '' ]">
                        <img :src="siteConfig.cdnUrl + '/KR/title/' + item.englishName + '.jpg'">
                        <div class="right">
                            <div class="right_top">
                                <h1>{{item.titleName}}</h1>
                                <h2>{{getCategoryName(item.category)}}</h2>
                                <!-- <h2>71화 연재</h2> -->
                                <!-- <p>#판타지 #로맨스<br>#소설원작</p> -->
                                <p class="introduce" v-html="item.desc"></p>
                            </div>
                            <!-- <div class="right_bottom">
                                <p>40%</p>
                                <p>5화 무료</p>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="next" @click="moveSlide('next', 'sale')">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
                <div class="prev" @click="moveSlide('prev', 'sale')">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
            </div>
        </div>
        <!-- section4 end -->
        <!-- section5 -->
        <div id="section5" class="section curation" v-if="genreHitList.length > 0">
            <div class="container">
                <h1 class="title">장르별 인기 순위</h1>
                <div class="row pc">
                    <div class="col show" v-for="(items, index) in genreHitList" :key="index">
                        <ul>
                            <li>
                                <h1>{{getCategoryName(Number(items.inner_data))}}</h1>
                                <router-link tag="a" :to="'/Category/' + Number(items.inner_data)" class="more">더보기 +</router-link>
                            </li>
                            <li v-for="(item, sub_index) in items.list" :key="sub_index" class="genre" :class="[sub_index > 0 ? 'genre2' : 'genre1']" @click="moveDetail(item)">
                                <img :src="siteConfig.cdnUrl + '/KR/horizontatitle/' + item.englishName + '.jpg'" v-if="sub_index === 0">
                                <div class="text_box" v-if="sub_index === 0">
                                    <!-- <img :src="siteConfig.cdnUrl + item.titleImg"> -->
                                    <p>1</p>
                                    <p>{{item.titleName}}</p>
                                </div>
                                <p class="number" v-if="sub_index > 0">{{sub_index + 1}}</p>
                                <div class="text"  v-if="sub_index > 0">
                                    <p class="name">{{item.titleName}}</p>
                                    <p class="introduce" v-html="item.desc"></p>
                                </div>
                                <img :src="siteConfig.cdnUrl + '/KR/smaltitle/' + item.englishName + '.jpg'" v-if="sub_index > 0">
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="next" @click="moveSlide('next', 'genreHit')">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
                <div class="prev" @click="moveSlide('prev', 'genreHit')">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
                <div class="pagenation">
                    <div class="circle" :class="[index === selectedGenreHitSlideIdx ? 'check' : '']" v-for="(item, index) in genreHitList" :key="index" @click="changeSlideIdx('genreHit', index)"></div>
                </div> -->
                <div class="popular_mobile" v-for="(items, index) in genreHitList" :key="index">
                    <h1>{{getCategoryName(Number(items.inner_data))}}</h1>
                    <div class="row">
                        <div v-for="(item, sub_index) in items.list" :key="sub_index" class="col show" @click="moveDetail(item)">
                            <img src="../assets/images/adult_mark.svg" alt="성인 마크" class="adult_mark" v-if="item.adult === 1">
                            <div class="top">
                                <img :src="siteConfig.cdnUrl + '/KR/title/' + item.englishName + '.jpg'">
                            </div>
                            <div class="bottom">
                                <p class="name">{{sub_index + 1}}. {{item.titleName}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- section5 end -->
        <!-- advertising2 -->
        <div id="advertising2" class="advertising">
            <router-link tag="div" to="/Charge" class="container">
                <img src="../assets/images/advertising2.png" alt="자동 지급">
            </router-link>
        </div>
        <!-- advertising2 end -->
        <!-- section6 -->
        <div id="section6" class="section curation" v-if="classicList.length > 0">
            <div class="container">
                <div class="m_more_box">
                    <h1 class="title">명작 추천</h1>
                    <!-- <router-link tag="a" to="/" class="more">더보기 +</router-link> -->
                </div>
                <h3 class="sub_title">강력한 역대급 명작을 확인하세요!</h3>
                <!-- <div class="pagenation">
                    <div class="circle" :class="[index === selectedClassicSlideIdx ? 'check' : '']" v-for="(item, index) in classicList" :key="index" @click="changeSlideIdx('classic', index)"></div>
                </div> -->
                <div class="row">
                    <div v-for="(item, index) in classicList" :key="index" class="col" :class="[index >= selectedClassicSlideIdx && index < selectedClassicSlideIdx + 5 ? 'show' : '' ]"  @click="moveDetail(item)">
                        <img src="../assets/images/adult_mark.svg" alt="성인 마크" class="adult_mark" v-if="item.adult === 1">
                        <div class="top">
                            <img :src="siteConfig.cdnUrl + '/KR/title/' + item.englishName + '.jpg'">
                        </div>
                        <div class="middle">
                            <p class="genre_2">{{getCategoryName(item.category)}}</p>
                            <!-- <p class="up_check">UP</p>
                            <p class="event">이벤트</p> -->
                        </div>
                        <div class="bottom">
                            <p class="name">{{item.titleName}}</p>
                            <p class="introduce" v-html="item.desc"></p>
                        </div>
                    </div>
                </div>
                <div class="next" @click="moveSlide('next', 'classic')">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
                <div class="prev" @click="moveSlide('prev', 'classic')">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
            </div>
        </div>
        <!-- section6 end -->
        <!-- section7 -->
        <div id="section7" class="section">
        <!-- <div id="section7" class="section">  -->
            <div class="container">
                <h1 class="title">인기 장르 소개</h1>
                <h3 class="sub_title">재미로 보는 장르추천!</h3>
                <div class="popular_box">
                    <!-- <div  class="main"  @click="moveDetail(hitGenreFeatured[0])"> -->
                    <router-link tag="div" to="/Category/6" class="main">
                        <div class="top">
                            <!-- <img :src="siteConfig.cdnUrl + '/KR/bigtitle/' + hitGenreFeatured[0].imgUrl + '.jpg'"> -->
                            <img src="../assets/images/popular/popular1.jpg" alt="썸네일"/>
                        </div>
                        <div class="bottom">
                            <!-- <p class="name">{{hitGenreFeatured[0].titleName}}</p>
                            <p class="intro">{{hitGenreFeatured[0].desc}}</p> -->
                            <p class="name">액션</p>
                            <p class="intro">무술의 민족, 한국인이 가장 사랑하는 장르. <br>역동적인 액션으로 센세이션을 불러일으킬 작품들!</p>
                            <div class="hash">
                                <p class="words_2">#액션</p>
                                <p class="words_4">#오감만족</p>
                                <p class="words_3">#히어로</p>
                            </div>
                        </div>
                    </router-link>
                    <div class="sub">
                        <div class="row">
                            <!-- <router-link tag="div" :to="'/Toondetail/' + item.englishName" v-for="(item, index) in hitGenreList[0].list" :key="index" class="col">    
                                <div class="bg">
                                    <img :src="siteConfig.cdnUrl + '/KR/category/' + item.imgUrl + '.jpg'"/>
                                </div>
                                <div class="content">
                                    <p class="name">{{item.titleName}}</p>
                                    <p class="intro">{{item.desc}}</p>
                                    <div class="hash">
                                        <p class="words_2">#액션</p>
                                        <p class="words_4">#액션쾌감</p>
                                        <p class="words_2">#학원</p>
                                        <p class="words_5">#아드레날린</p>
                                    </div>
                                </div>
                            </router-link> -->
                            <!-- <div class="col" v-for="(item, index) in hitGenreList[0].list" :key="index" @click="moveDetail(item)"> -->
                            <router-link tag="div" to="/Category/1" class="col">
                                <div class="bg">
                                    <!-- <img :src="siteConfig.cdnUrl + '/KR/cover/' + item.imgUrl + '.jpg'"/> -->
                                    <img src="../assets/images/popular/popular2.png" alt="썸네일" />
                                </div>
                                <div class="content">
                                    <!-- <p class="name">{{item.titleName}}</p>
                                    <p class="intro">{{item.desc}}</p> -->
                                    <p class="name">로맨스</p>
                                    <p class="intro">기존 로맨스 장르의 틀을 깨는 신박한 소재와 <br>유쾌한 케미스트리를 예고하는 로맨스를 만나보세요!</p>
                                    <div class="hash">
                                        <p class="words_2">#순애</p>
                                        <p class="words_4">#사내연애</p>
                                        <p class="words_4">#비밀관계</p>
                                        <p class="words_6">#로맨틱코미디</p>
                                    </div>
                                </div>
                            </router-link>
                            <router-link tag="div" to="Category/8" class="col">
                                <div class="bg">
                                    <img src="../assets/images/popular/popular3.png" alt="썸네일" />
                                </div>
                                <div class="content">
                                    <p class="name">무협</p>
                                    <p class="intro">강호속에서 펼쳐지는 절대 무림 고수들의 대 서사시 <br>의리와 낭만을 아는 당신은 무협매니아!</p>
                                    <div class="hash">
                                        <p class="words_2">#무협</p>
                                        <p class="words_2">#낭만</p>
                                        <p class="words_2">#의리</p>
                                        <p class="words_5">#강호의도리</p>
                                    </div>
                                </div>
                            </router-link>
                            <router-link tag="div" to="/Category/3" class="col">
                                <div class="bg">
                                    <img src="../assets/images/popular/popular4.png" alt="썸네일" />
                                </div>
                                <div class="content">
                                    <p class="name">판타지</p>
                                    <p class="intro">장르문학의 보편적 코드로 자리잡은 판타지 대작 모음 <br>심오하고 환상적인 세계관에서 맛보는 장르적 쾌감!</p>
                                    <div class="hash">
                                        <p class="words_3">#초능력</p>
                                        <p class="words_2">#요리</p>
                                        <p class="words_4">#시간조종</p>
                                        <p class="words_3">#빙의물</p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- section7 end -->
        <!-- section8 -->
        <div id="section8" class="section" v-if="keywordFullList.length > 0">
            <div class="container">
                <h1 class="title">맞춤키워드</h1>
                <h3 class="sub_title">AI 추천으로 나에게 딱 맞는 작품들을 만나보세요!</h3>
                <b-row cols="8" class="menu">
                    <!-- <router-link tag="div" to="/Hashtag/0" class="col">#전체</router-link> -->
                    <b-col tag="div" v-for="(item, index) in hashList" :key="index" @click="changeHashTag(item.hsIdx)" :class="{'active' : item.hsIdx === selectedKeywordTagIdx}">
                        {{item.hsName}}
                    </b-col>
                </b-row>
                <!-- <div class="pagenation">
                    <div class="circle" :class="[index === selectedKeywordSlideIdx ? 'check' : '']" v-for="(item, index) in keywordList" :key="index" @click="changeSlideIdx('keyword', index)"></div>
                </div> -->
                <div class="contents_box curation">
                    <div class="row">
                        <div v-for="(item, index) in keywordList" :key="index" class="col" :class="[index >= selectedKeywordSlideIdx && index < selectedKeywordSlideIdx + 5 ? 'show' : '']" @click="moveDetail(item)">
                            <img src="../assets/images/adult_mark.svg" alt="성인 마크" class="adult_mark" v-if="item.adult === 1">
                            <div class="top">
                                <img :src="siteConfig.cdnUrl + '/KR/title/' + item.englishName + '.jpg'"/>
                            </div>
                            <div class="middle">
                                <p class="genre_2">{{getCategoryName(item.category)}}</p>
                                <!-- <p class="up_check">UP</p>
                                <p class="event">이벤트</p> -->
                            </div>
                            <div class="bottom">
                                <p class="name">{{item.titleName}}</p>
                                <p class="introduce" v-html="item.desc"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="next" @click="moveSlide('next', 'keyword')" v-if="keywordList.length > 0">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
                <div class="prev" @click="moveSlide('prev', 'keyword')" v-if="keywordList.length > 0">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
            </div>
        </div>
        <!-- section8 end -->
        <!-- section9 -->
        <div id="section9" class="section curation" v-if="waitFreeList.length > 0">
            <div class="container">
                <div class="m_more_box">
                    <h1 class="title">기다리면 무료</h1>
                    <!-- <router-link tag="a" to="/" class="more">더보기 +</router-link> -->
                </div>
                <h3 class="sub_title">매일 한편씩 무료로 즐겨보세요!</h3>
                <!-- <div class="pagenation">
                    <div class="circle" :class="[index === selectedWaitFreeSlideIdx ? 'check' : '']" v-for="(item, index) in waitFreeList" :key="index" @click="changeSlideIdx('waitFree', index)"></div>
                </div> -->
                <div class="row">
                    <div v-for="(item, index) in waitFreeList" :key="index" class="col" :class="[index >= selectedWaitFreeSlideIdx && index < selectedWaitFreeSlideIdx + 5 ? 'show' : '' ]" @click="moveDetail(item)">
                        <div class="top">
                            <img :src="siteConfig.cdnUrl + '/KR/title/' + item.englishName + '.jpg'"/>
                        </div>
                        <div class="middle">
                            <p class="genre_2">{{getCategoryName(item.category)}}</p>
                            <!-- <p class="up_check">UP</p>
                            <p class="event">이벤트</p> -->
                        </div>
                        <div class="bottom">
                            <p class="name">{{item.titleName}}</p>
                            <p class="introduce" v-html="item.desc"></p>
                        </div>
                    </div>
                </div>
                <div class="next" @click="moveSlide('next', 'waitFree')">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
                <div class="prev" @click="moveSlide('prev', 'waitFree')">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
            </div>
        </div>
        <!-- section9 end -->
        <!-- section10 -->
        <div id="section10" class="section curation" v-if="bestCompleteList.length > 0">
            <div class="container">
                <div class="m_more_box">
                    <h1 class="title">베스트 완결작</h1>
                    <!-- <router-link tag="a" to="/" class="more">더보기 +</router-link> -->
                </div>
                <h3 class="sub_title">아튜브 추천 베스트 완결작 모음</h3>
                <!-- <div class="pagenation">
                    <div class="circle" :class="[index === selectedBestCompleteSlideIdx ? 'check' : '']" v-for="(item, index) in bestCompleteList" :key="index" @click="changeSlideIdx('bestComplete', index)"></div>
                </div> -->
                <div class="row">
                    <div v-for="(item, index) in bestCompleteList" :key="index" class="col" :class="[index >= selectedBestCompleteSlideIdx && index < selectedBestCompleteSlideIdx + 5 ? 'show' : '' ]" @click="moveDetail(item)">
                        <img src="../assets/images/adult_mark.svg" alt="성인 마크" class="adult_mark" v-if="item.adult === 1">
                        <div class="top">
                            <img :src="siteConfig.cdnUrl + '/KR/title/' + item.englishName + '.jpg'">
                        </div>
                        <div class="middle">
                            <p class="genre_2">{{getCategoryName(item.category)}}</p>
                            <!-- <p class="up_check">UP</p> -->
                        </div>
                        <div class="bottom">
                            <p class="name">{{item.titleName}}</p>
                            <p class="introduce" v-html="item.desc"></p>
                        </div>
                    </div>
                </div>
                <div class="next" @click="moveSlide('next', 'bestComplete')">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
                <div class="prev" @click="moveSlide('prev', 'bestComplete')">
                    <img src="../assets/images/next.svg" alt="next">
                </div>
            </div>
        </div>
        <!-- section10 end -->
        <!-- advertising3 -->
        <!-- <div id="advertising3" class="advertising">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <img src="../assets/images/freecoin.webp" alt="무료충전">
                    </div>
                    <div class="col">
                        <img src="../assets/images/onecut.webp" alt="한 컷 웹툰">
                    </div>
                </div>
            </div>
        </div> -->
        <!-- advertising3 end -->
        <!-- advertising3 -->
        <div id="advertising1" class="advertising">
            <router-link tag="div" to="/LeagueEvent" class="container">
                <img src="../assets/images/league_banner2.png" alt="업로드이벤트 오픈">
            </router-link>
        </div>
        <!-- advertising3 end -->
        <Footer />
        <Login :initIsShowPopup="isShowLoginPopup" @close="close('Login')" />
        <PopupNotice />
    </div>
</template>

<script>

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Tabs from '@/components/Tabs.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import Login from '@/components/Login.vue'
import PopupNotice from '@/components/PopupNotice.vue'

export default {
name: 'Home',
    pageCategory: '',
    components: {
        Header,
        Tabs,
        Footer,
        VueSlickCarousel,
        Login,
        PopupNotice,
    },
    
    data() {
        return {
            isColorBlack: false,
            selectedFeaturedSlideIdx: 0,
            settings0:{lazyLoad: "ondemand", dots: true, arrows: true, fade: false, infinite: true, speed: 500, autoplaySpeed: 5000, slidesToShow: 1, slidesToScroll: 1, autoplay: true,},
            // settings1:{lazyLoad: "ondemand", dots: false, arrows: false, fade: false, infinite: true, speed: 500, autoplaySpeed: 5000, slidesToShow: 1, slidesToScroll: 1, autoplay: false,},
            // settings2:{lazyLoad: "ondemand", dots: false, arrows: false, fade: false, infinite: true, speed: 500, autoplaySpeed: 5000, slidesToShow: 1, slidesToScroll: 1, autoplay: false,},
            // settings3:{lazyLoad: "ondemand", dots: false, arrows: false, fade: false, infinite: true, speed: 500, autoplaySpeed: 5000, slidesToShow: 1, slidesToScroll: 1, autoplay: false,},
            // settings4:{lazyLoad: "ondemand", dots: false, arrows: false, fade: false, infinite: true, speed: 500, autoplaySpeed: 5000, slidesToShow: 3, slidesToScroll: 1, autoplay: false,},
            // settings5:{lazyLoad: "ondemand", dots: false, arrows: false, fade: false, infinite: true, speed: 500, autoplaySpeed: 5000, slidesToShow: 1, slidesToScroll: 1, autoplay: false,},
            // settings6:{lazyLoad: "ondemand", dots: false, arrows: false, fade: false, infinite: true, speed: 500, autoplaySpeed: 5000, slidesToShow: 1, slidesToScroll: 1, autoplay: false,},
            // settings7:{lazyLoad: "ondemand", dots: false, arrows: false, fade: false, infinite: true, speed: 500, autoplaySpeed: 5000, slidesToShow: 1, slidesToScroll: 1, autoplay: false,},
            // settings8:{lazyLoad: "ondemand", dots: false, arrows: false, fade: false, infinite: true, speed: 500, autoplaySpeed: 5000, slidesToShow: 1, slidesToScroll: 1, autoplay: false,},
            // settings9:{lazyLoad: "ondemand", dots: false, arrows: false, fade: false, infinite: true, speed: 500, autoplaySpeed: 5000, slidesToShow: 1, slidesToScroll: 1, autoplay: false,},
            
            categoryList: [],
            hashList: [],

            featuredList : [],
            bannerList: [],

            //큐레이션 타입별 전체 데이터 리스트
            newUpdateList    : [],  //0 신규 업데이트 
            hitFeatured      : [],  //1 인기작품 메인 작품
            hitList          : [],  //1 인기작품
            saleList         : [],  //2 할인작품
            genreHitList     : [],  //3 장르별인기순위
            classicList      : [],  //4 명작추천
            hitGenreFeatured : [],  //5 인기장르소개 메인 작품
            hitGenreList     : [],  //5 인기장르소개
            keywordFullList  : [],  //6 맞춤키워드 전체 리스트
            keywordList      : [],  //6 맞춤키워드
            waitFreeList     : [],  //7 기다리면무료
            bestCompleteList : [],  //8 베스트완결작

            //화면에 표시중인 슬라이드 인덱스 번호
            selectedNewUpdateSlideIdx        : 0, //0 신규 업데이트 
            selectedHitFeaturedSlideIdx      : 0, //1 인기작품 메인 작품
            selectedHitSlideIdx              : 0, //1 인기작품
            selectedSaleSlideIdx             : 0, //2 할인작품
            selectedGenreHitSlideIdx         : 2, //3 장르별인기순위
            selectedClassicSlideIdx          : 0, //4 명작추천
            selectedHitGenreFeaturedSlideIdx : 0, //5 인기장르소개 메인 작품
            selectedHitGenreSlideIdx         : 0, //5 인기장르소개
            selectedKeywordSlideIdx          : 0, //6 맞춤키워드
            selectedWaitFreeSlideIdx         : 0, //7 기다리면무료
            selectedBestCompleteSlideIdx     : 0, //8 베스트완결작
                                        
            //화면에 표시중인 항목
            selectedNewUpdateSlideItem        : null, //0 신규 업데이트
            selectedHitFeaturedSlideItem      : null, //1 인기작품 메인 작품
            selectedHitSlideItem              : null, //1 인기작품
            selectedSaleSlideItem             : null, //2 할인작품
            selectedGenreHitSlideItem         : null, //3 장르별인기순위
            selectedClassicSlideItem          : null, //4 명작추천
            selectedHitGenreFeaturedSlideItem : null, //5 인기장르소개 메인 작품
            selectedHitGenreSlideItem         : null, //5 인기장르소개
            selectedKeywordSlideItem          : null, //6 맞춤키워드
            selectedWaitFreeSlideItem         : null, //7 기다리면무료
            selectedBestCompleteSlideItem     : null, //8 베스트완결작

            //
            selectedKeywordTagIdx: 0,

            isShowLoginPopup: false,
            
        }
    },
    async created(){
        await this.mixinSiteConfigCheck();
        await this.mixinLoginCheck();

        this.getCategory();
        await this.getHash();

        this.getBanner();

        this.getNewUpdate();        //0 신규 업데이트 
        this.getHit();              //1 인기작품
        this.getSale();             //2 할인작품
        this.getGenreHit();         //3 장르별인기순위
        this.getClassic();          //4 명작추천
        this.getHitGenre();         //5 인기장르소개
        this.getKeyword();          //6 맞춤키워드
        this.getWaitFree();         //7 기다리면무료
        this.getBestComplete();     //8 베스트완결작

    },
    mounted(){
        setTimeout(()=>{window.scroll(0,0)}, 500) ;
    },
    methods: {
        handleBeforeChange(event, slick, slider_no) {
            if(slider_no === 0){
                //console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
                this.selectedFeaturedSlideIdx = Number(slick);
            }
        },
        changeSlide(idx){
            this.selectedFeaturedSlideIdx = idx;
            this.$refs.featuredSlider.goTo(idx, true);
        },
        moveSlide(arrow, type){
            switch(type){
                case "newUpdate":
                    if(arrow === 'next' && this.selectedNewUpdateSlideIdx + 6 < this.newUpdateList.length){this.selectedNewUpdateSlideIdx += 1;}
                    else if(arrow === 'prev' && this.selectedNewUpdateSlideIdx - 1 >= 0){this.selectedNewUpdateSlideIdx -= 1;}
                    // this.selectedNewUpdateSlideItem = this.newUpdateList[this.selectedNewUpdateSlideIdx];
                    break;
                case "hit":
                    if(arrow === 'next' && this.selectedHitSlideIdx + 1 < this.hitList.length){this.selectedHitSlideIdx += 1;}
                    else if(arrow === 'prev' && this.selectedHitSlideIdx - 1 >= 0){this.selectedHitSlideIdx -= 1;}
                    // this.selectedHitSlideItem = this.hitList[this.selectedHitSlideIdx];

                    if(arrow === 'next' && this.selectedHitFeaturedSlideIdx + 1 < this.hitFeatured.length){this.selectedHitFeaturedSlideIdx += 1;}
                    else if(arrow === 'prev' && this.selectedHitFeaturedSlideIdx - 1 >= 0){this.selectedHitFeaturedSlideIdx -= 1;}
                    // this.selectedHitFeaturedSlideItem = this.hitFeatured[this.selectedHitFeaturedSlideIdx];
                    break;
                case "sale":
                    if(arrow === 'next' && this.selectedSaleSlideIdx + 5 < this.saleList.length){this.selectedSaleSlideIdx += 1;}
                    else if(arrow === 'prev' && this.selectedSaleSlideIdx - 1 >= 0){this.selectedSaleSlideIdx -= 1;}
                    // this.selectedSaleSlideItem = this.saleList[this.selectedSaleSlideIdx];
                    break;
                case "genreHit":
                    if(arrow === 'next' && this.selectedGenreHitSlideIdx + 1 < this.genreHitList.length){this.selectedGenreHitSlideIdx += 1;}
                    else if(arrow === 'prev' && this.selectedGenreHitSlideIdx - 1 >= 2){this.selectedGenreHitSlideIdx -= 1;}
                    // this.selectedGenreHitSlideItem = this.genreHitList[this.selectedGenreHitSlideIdx];
                    break;
                case "classic":
                    if(arrow === 'next' && this.selectedClassicSlideIdx + 5 < this.classicList.length){this.selectedClassicSlideIdx += 1;}
                    else if(arrow === 'prev' && this.selectedClassicSlideIdx - 1 >= 0){this.selectedClassicSlideIdx -= 1;}
                    // this.selectedClassicSlideItem = this.classicList[this.selectedClassicSlideIdx];
                    break;
                case "hitGenre":
                    if(arrow === 'next' && this.selectedHitGenreSlideIdx + 1 < this.hitGenreList.length){this.selectedHitGenreSlideIdx += 1;}
                    else if(arrow === 'prev' && this.selectedHitGenreSlideIdx - 1 >= 0){this.selectedHitGenreSlideIdx -= 1;}
                    // this.selectedHitGenreSlideItem = this.hitGenreList[this.selectedHitGenreSlideIdx];

                    if(arrow === 'next' && this.selectedHitGenreFeaturedSlideIdx + 1 < this.hitGenreFeatured.length){this.selectedHitGenreFeaturedSlideIdx += 1;}
                    else if(arrow === 'prev' && this.selectedHitGenreFeaturedSlideIdx - 1 >= 0){this.selectedHitGenreFeaturedSlideIdx -= 1;}
                    // this.selectedHitGenreFeaturedSlideItem = this.hitGenreFeatured[this.selectedHitGenreFeaturedSlideIdx];
                    break;
                case "keyword":
                    if(arrow === 'next' && this.selectedKeywordSlideIdx + 5 < this.keywordList.length){this.selectedKeywordSlideIdx += 1;}
                    else if(arrow === 'prev' && this.selectedKeywordSlideIdx - 1 >= 0){this.selectedKeywordSlideIdx -= 1;}
                    // this.selectedKeywordSlideItem = this.keywordList[this.selectedKeywordSlideIdx];
                    break;
                case "waitFree":
                    if(arrow === 'next' && this.selectedWaitFreeSlideIdx + 5 < this.waitFreeList.length){this.selectedWaitFreeSlideIdx += 1;}
                    else if(arrow === 'prev' && this.selectedWaitFreeSlideIdx - 1 >= 0){this.selectedWaitFreeSlideIdx -= 1;}
                    // this.selectedWaitFreeSlideItem = this.waitFreeList[this.selectedWaitFreeSlideIdx];
                    break;
                case "bestComplete":
                    if(arrow === 'next' && this.selectedBestCompleteSlideIdx + 5 < this.bestCompleteList.length){this.selectedBestCompleteSlideIdx += 1;}
                    else if(arrow === 'prev' && this.selectedBestCompleteSlideIdx - 1 >= 0){this.selectedBestCompleteSlideIdx -= 1;}
                    // this.selectedBestCompleteSlideItem = this.bestCompleteList[this.selectedBestCompleteSlideIdx];
                    break;
            }
        },
        changeSlideIdx(type, idx){
            switch(type){
                case "newUpdate":
                    this.selectedNewUpdateSlideIdx = idx;
                    this.selectedNewUpdateSlideItem = this.newUpdateList[this.selectedNewUpdateSlideIdx];
                    break;
                case "hit":
                    this.selectedHitSlideIdx = idx;
                    this.selectedHitSlideItem = this.hitList[this.selectedHitSlideIdx];

                    this.selectedHitFeaturedSlideIdx = idx;
                    this.selectedHitFeaturedSlideItem = this.hitFeatured[this.selectedHitFeaturedSlideIdx];
                    break;
                case "sale":
                    this.selectedSaleSlideIdx = idx;
                    this.selectedSaleSlideItem = this.saleList[this.selectedSaleSlideIdx];
                    break;
                case "genreHit":
                    break;
                case "classic":
                    this.selectedClassicSlideIdx = idx;
                    this.selectedClassicSlideItem = this.classicList[this.selectedClassicSlideIdx];
                    break;
                case "hitGenre":
                    this.selectedHitGenreSlideIdx = idx;
                    this.selectedHitGenreSlideItem = this.hitGenreList[this.selectedHitGenreSlideIdx];

                    this.selectedHitGenreFeaturedSlideIdx = idx;
                    this.selectedHitGenreFeaturedSlideItem = this.hitGenreFeatured[this.selectedHitGenreFeaturedSlideIdx];
                    break;
                case "keyword":
                    this.selectedKeywordSlideIdx  = idx;
                    this.selectedKeywordSlideItem = this.keywordList[this.selectedKeywordSlideIdx];
                    break;
                case "waitFree":
                    this.selectedWaitFreeSlideIdx  = idx;
                    this.selectedWaitFreeSlideItem = this.waitFreeList[this.selectedWaitFreeSlideIdx];
                    break;
                case "bestComplete":
                    this.selectedBestCompleteSlideIdx  = idx;
                    this.selectedBestCompleteSlideItem = this.bestCompleteList[this.selectedBestCompleteSlideIdx];
                    break;
            }
        },
        changeHashTag(hsIdx){

            if(this.selectedKeywordTagIdx === hsIdx){
                return;
            }
            
            this.selectedKeywordTagIdx = hsIdx;
            this.keywordList = [];
            this.selectedKeywordSlideIdx = 0;

            // console.log(this.keywordFullList);

            this.keywordFullList.forEach(element =>{
                // console.log(element.hsIdx);
                // console.log(hsIdx);
                if(element.hsIdx === hsIdx){
                    this.keywordList.push(element);
                    // console.log(element.hsName);
                }
            })
        }, 
        getCategory(){ // 카테고리 정보
            var param = 
            {
                // limit : 3
            }
            this.$Axios.post(`${this.host}/infocategory`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                if (res.data.returnCode === 0) {
                    this.categoryList = res.data.list;
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getCategoryName(category_idx){
            var name = '';
            this.categoryList.forEach(element =>{
                if(category_idx === element.idx){
                    // console.log('----------')
                    // console.log(category_idx);
                    // console.log(element.idx)
                    // console.log(element.name)
                    // console.log('----------')
                    name = element.name;
                }
            })
            return name;
        },
        async getHash(){ // 해시 태그 정보

            this.mixin_hashtagList.forEach(item =>{
                if(item.adult === this.$store.state.isCheckedAdult){
                    this.hashList.push(item);
                }
            })

            this.selectedKeywordTagIdx = this.hashList[0].hsIdx;
            

            // var param = 
            // {
            //     // limit : 3
            // }
            // await this.$Axios.post(`${this.host}/infotag`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
            //     console.log('----태그----');
            //     console.log(res.data);
            //     if (res.data.returnCode === 0) {
            //         this.hashList = res.data.list;
            //         if(this.hashList.length > 0){
            //             this.selectedKeywordTagIdx = this.hashList[0].hsIdx;
            //         }
            //     }
            // })
            // .catch((error) => {
            //     console.log(error);
            // });
        },
        getHashName(hash_idx){
            var name = '';
            this.hashList.forEach(element =>{
                if(hash_idx === element.hsIdx){
                    name = element.hsName;
                }
            })
            return name;
        },
        getBanner(){
            var param = 
            {
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/banner`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log('----배너----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.bannerList = res.data.list;
                    this.bannerList.sort(function(){
                        return Math.random() - Math.random();
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getNewUpdate(){ // 0 신규 업데이트 작품
            var param = 
            {
                type: 0,
                setCount: 5,
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/curation`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('----신규 업데이트 작품----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    res.data.setList.forEach(element => {
                        element.list.forEach(element2 =>{
                            this.newUpdateList.push(element2);
                        })
                    })
                    // this.newUpdateList = res.data.setList;
                    if(this.newUpdateList.length > 0){
                        this.selectedNewUpdateSlideIdx = 0;
                        // this.selectedNewUpdateSlideItem = this.newUpdateList[0];
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getHit(){  // 1 인기 작품
            var param = 
            {
                type: 1,
                setCount: 7,
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/curation`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('----인기 작품----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.hitList = res.data.setList;
                    this.hitList.forEach((item, index) => {
                        this.hitFeatured.push(item.list[0]);
                        this.hitList[index].list.shift();
                    });

                    if(this.hitList.length > 0){
                        this.selectedHitSlideIdx = 0;
                        // this.selectedHitSlideItem = this.hitList[0];

                        this.selectedHitFeaturedSlideIdx = 0;
                        // this.selectedHitFeaturedSlideItem = this.hitFeatured[0];
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getSale(){  // 2 할인 작품
            var param = 
            {
                type: 2,
                setCount: 4,
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/curation`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('----할인 작품----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    res.data.setList.forEach(element => {
                        element.list.forEach(element2 =>{
                            this.saleList.push(element2);
                        })
                    })

                    if(this.saleList.length > 0){
                        this.selectedSaleSlideIdx = 0;
                        // this.selectedSaleSlideItem = this.saleList[0];
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getGenreHit(){  // 3 장르별 인기 순위
            var param = 
            {
                type: 3,
                setCount: 5,
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/curation`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('----장르별 인기 순위----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.genreHitList = res.data.setList;
                    if(this.genreHitList.length > 0){
                        this.selectedGenreHitSlideIdx = 0;
                        // this.selectedGenreHitSlideItem = this.genreHitList[0];
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getClassic(){  // 4 명작추천
            var param = 
            {
                type: 4,
                setCount: 5,
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/curation`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('----명작 추천----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    res.data.setList.forEach(element => {
                        element.list.forEach(element2 =>{
                            this.classicList.push(element2);
                        })
                    })

                    if(this.classicList.length > 0){
                        this.selectedClassicSlideIdx = 0;
                        // this.selectedClassicSlideItem = this.classicList[0];
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getHitGenre(){  // 5 인기장르소개
            var param = 
            {
                type: 5,
                setCount: 4,
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/curation`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('----인기 장르 소개----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.hitGenreList = res.data.setList;
                    this.hitGenreList.forEach((item, index) => {
                        this.hitGenreFeatured.push(item.list[0]);
                        this.hitGenreList[index].list.shift();
                    });

                    if(this.hitGenreList.length > 0){
                        this.selectedHitGenreSlideIdx = 0;
                        // this.selectedHitGenreSlideItem = this.hitGenreList[0];

                        this.selectedHitGenreFeaturedSlideIdx = 0;
                        // this.selectedHitGenreFeaturedSlideItem = this.hitGenreFeatured[0];
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getKeyword(){  // 6 맞춤키워드
            var param = 
            {
                type: 6,
                setCount: 100,
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            // console.log(param)
            this.$Axios.post(`${this.host}/curation`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('----맞춤 키워드----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    res.data.setList.forEach(element => {
                        element.list.forEach(element2 =>{
                            element2.hsIdx = Number(element.inner_data);
                            this.keywordFullList.push(element2);

                            if(element2.hsIdx === this.selectedKeywordTagIdx){
                                this.keywordList.push(element2);
                            }
                        })
                    })
                    // console.log(this.keywordList);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getWaitFree(){  // 7 기다리면 무료
            var param = 
            {
                type: 7,
                setCount: 5,
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/curation`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('----기다리면 무료----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    res.data.setList.forEach(element => {
                        element.list.forEach(element2 =>{
                            this.waitFreeList.push(element2);
                        })
                    })
                    if(this.waitFreeList.length > 0){
                        this.selectedWaitFreeSlideIdx = 0;
                        // this.selectedWaitFreeSlideItem = this.waitFreeList[0];
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },

        getBestComplete(){  // 8 베스트 완결작
            var param = 
            {
                type: 8,
                setCount: 5,
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/curation`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('----베스트 완결작----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    res.data.setList.forEach(element => {
                        element.list.forEach(element2 =>{
                            this.bestCompleteList.push(element2);
                        })
                    })
                    if(this.bestCompleteList.length > 0){
                        this.selectedBestCompleteSlideIdx = 0;
                        // this.selectedBestCompleteSlideItem = this.bestCompleteList[0];
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },

        moveDetail(item){
            if(item.adult === 1){
                if(this.$store.state.loginCheck === false){
                    this.isShowLoginPopup = true;
                }
                else if(!this.$store.state.adult){
                    var src = this.siteConfig.niceUrl + '?email=' + this.$store.state.email;
                    window.open(src, 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=no');
                }
                else{
                    // this.$router.push('/Toondetail/' + item.englishName);
                    this.$router.push('/Toondetail/' + item.webToonIndex);
                }
            }else{
                // this.$router.push('/Toondetail/' + item.englishName);
                this.$router.push('/Toondetail/' + item.webToonIndex);
            }
            
        },
        close(popupType){
            switch(popupType){
                case 'Login':
                    this.isShowLoginPopup = false;
                    break;
            }
        },
        bannerClick(item){
            // console.log(item);
            
            if(item.linkType === 0){
                this.$router.push(item.link);
                // location.href = item.link;
                // console.log(item);
            }
            else if(item.linkType === 1){
                var src = this.siteConfig.niceUrl + '?email=' + this.$store.state.email;

                var param = 
                {
                    idx: item.link,
                    sign: this.$store.state.sign,
                    ticket: this.$store.state.ticket,
                    viewAdult: this.$store.state.isCheckedAdult ? 1 : 0,
                }
                this.$Axios.post(`${this.host}/webtoon`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                    // console.log('--webtoon info--')
                    // console.log(res.data);
                    if (res.data.returnCode === 0) {
                        if(res.data.data.adult === 1){
                            if(this.$store.state.loginCheck === false){
                                this.isShowLoginPopup = true;
                            }
                            else if(this.$store.state.adult === false){
                                window.open(src, 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=no');
                            }else{
                                this.$router.push('/Toondetail/' + item.link);
                            }
                        }else{
                            this.$router.push('/Toondetail/' + item.link);
                        }
                    }
                    else if(res.data.returnCode === 252){
                        window.open(src, 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=no');
                    }
                    else if(res.data.returnCode === 301){
                        this.isShowLoginPopup = true;
                    }
                    else{
                        this.$router.push('/');
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            }
        },
    },    
}
</script>

<style scoped>

</style>
